export const getOpenId = () => {
    return window.localStorage.getItem('openId');
}

export const getScreenInfo = () => {
    let width = window.innerWidth;
    let height = window.innerHeight;
    let rWidth = 7.5;
    let rHeight = (7.5 * height / width).toFixed(2);
    return {
        width,
        height,
        rWidth,
        rHeight
    };
}


// WEBPACK FOOTER //
// ./src/utils/index.js